export const bankAccountsPtBr = {
  statementSource: {
    fileOnly: 'Extrato por arquivo',
    enable: 'Usar extrato somente por arquivo',
    resume: 'Retomar extrato pelo Open Finance',
    description:
      'Os lançamentos e saldos desta conta deixarão de ser atualizados pelo Open Finance. Importe o extrato pelo botão Importar extrato. O histórico e as outras contas da conexão serão preservados.',
    resumeDescription:
      'O Open Finance voltará a atualizar os lançamentos e saldos desta conta. Depois, use Sincronizar pendências no período desejado. Se já houver importações, será necessário revisar a sobreposição antes de retomar a sincronização.',
    confirm: 'Confirmar alteração',
    processingTitle: 'Atualizando fonte do extrato',
    processingDescription:
      'Aguarde enquanto a conta é atualizada. Esta janela não pode ser fechada durante o processamento.',
    saved: 'Fonte do extrato atualizada.',
    successDescription: 'A conta agora usa a fonte selecionada. Você pode fechar esta janela.',
    errorTitle: 'Não foi possível atualizar a fonte',
    retry: 'Tentar novamente',
    error:
      'Não foi possível alterar a fonte. Se houver extratos importados, revise a sobreposição antes de retomar o Open Finance.',
    reloadFailed:
      'A fonte do extrato foi salva, mas a conta não pôde ser atualizada. Tente novamente para ver os dados atualizados.',
  },
  detail: {
    reloadFailed: 'A conta não pôde ser atualizada. O saldo em tela pode estar desatualizado.',
  },
  defaultBadge: 'Padrão',
  defaultTooltip: 'Essa conta é utilizada por padrão como origem para pagamentos',
  setDefault: 'Definir como padrão',
  glOffsetRequired: 'Vincule a conta contábil para permitir lançamentos.',
  glOffsetManualLink:
    'Nenhuma conta contábil encontrada para este banco. Vincule em Configurações > Contas bancárias e cartões.',
  glOffsetBannerOne:
    '1 conta ativa sem conta contábil vinculada. Edite para vincular e permitir lançamentos.',
  glOffsetBannerMany:
    '{{count}} contas ativas sem conta contábil vinculada. Edite para vincular e permitir lançamentos.',
  glOffsetBannerOneCreditCard:
    '1 cartão ativo sem conta contábil vinculada. Edite para vincular e permitir lançamentos.',
  glOffsetBannerManyCreditCard:
    '{{count}} cartões ativos sem conta contábil vinculada. Edite para vincular e permitir lançamentos.',
  glOffsetSelectHint:
    'Selecione a conta contábil para vincular na GL. Necessário para permitir lançamentos e conciliação.',
  glOffsetPending: 'GL pendente',
  glOffsetPendingTooltip:
    'Conta contábil não vinculada. Clique em Editar e selecione uma conta no campo "Conta contábil (GL)". Se não existir, crie em Configurações > Plano de contas.',
  page: {
    titleCreate: 'Nova conta bancária',
    titleEdit: 'Editar conta bancária',
    subtitleCreate: 'Preencha os dados para criar uma nova conta bancária',
    subtitleEdit: 'Atualize as informações da conta bancária',
  },
  sections: {
    basic: 'Informações básicas',
    banking: 'Dados bancários',
    pix: 'Chaves PIX',
    cnab: 'Configuração CNAB',
    balance: 'Saldo',
    payments: 'Envio de pagamentos',
  },
  fields: {
    entity: 'Entidade',
    status: 'Status',
    name: 'Nome',
    description: 'Descrição',
    glOffsetAccount: 'Conta contábil',
    ownerName: 'Titular',
    bank: 'Banco',
    bankCode: 'Código do Banco',
    bankName: 'Nome do Banco',
    investmentBankCode: 'Código do banco',
    investmentPlatformName: 'Nome da plataforma',
    branchCode: 'Agência',
    accountNumber: 'Número da Conta',
    clabe: 'CLABE',
    accountType: 'Tipo de Conta',
    currency: 'Moeda',
    isDefault: 'Definir como conta padrão',
    // ALC-4327 (Web-AC8): the ALC-4325 sweep flag.
    statementBalanceIncludesSweep: 'O saldo do extrato inclui o valor aplicado automaticamente',
    initialBalance: 'Saldo Inicial',
    paymentsEnabled: 'Habilitar envio de pagamentos',
  },
  // ALC-5154: the account's automatic sweep rules.
  sweepRule: {
    title: 'Aplicação automática',
    description:
      'Linhas que o banco aplica e resgata sozinho. Numa conta cujo saldo já inclui o valor aplicado, elas não entram no fluxo de caixa.',
    tableLabel: 'Regras de aplicação automática',
    noActor: 'Sem registro',
    notChanged: 'Nunca alterada',
    markedLink_one: 'Ver a linha marcada por esta regra',
    markedLink_other: 'Ver as {{number}} linhas marcadas por esta regra',
    columns: {
      words: 'A descrição contém',
      direction: 'Direção',
      marked: 'Linhas marcadas',
      createdBy: 'Criada por',
      updatedBy: 'Alterada por',
      status: 'Situação',
    },
    direction: { DEBIT: 'Saídas', CREDIT: 'Entradas', BOTH: 'Ambas' },
    status: { active: 'Ativa', off: 'Desligada' },
    actions: {
      menu: 'Ações da regra {{words}}',
      edit: 'Editar',
      viewLines: 'Ver linhas',
      turnOff: 'Desligar',
      turnOn: 'Ligar',
    },
    empty: {
      title: 'Nenhuma regra ainda',
      description:
        'Marque uma linha como aplicação automática na conciliação e o sistema propõe a regra.',
      action: 'Abrir a conciliação',
    },
  },
  placeholders: {
    selectEntity: 'Selecione a entidade',
    selectStatus: 'Selecione o status',
    name: 'Ex: Conta Corrente Bradesco',
    description: 'Descrição opcional da conta bancária',
    ownerName: 'Ex: EMPRESA LTDA',
    bankSearch: 'Buscar por nome ou código...',
    bankCode: 'Ex: 237',
    bankName: 'Ex: Banco Bradesco S.A.',
    investmentBankCode: 'Ex: 102 (XP), 208 (BTG)',
    investmentPlatformName: 'Ex: XP, BTG, Clear',
    branchCode: 'Ex: 1234',
    accountNumber: 'Ex: 12345-6',
    clabe: 'CLABE de 18 dígitos',
    selectAccountType: 'Selecione o tipo de conta',
    selectCurrency: 'Selecione a moeda',
    selectGlAccount: 'Selecione a conta contábil para vincular na GL',
    initialBalance: 'Ex: 10.000,00',
  },
  hints: {
    bankCode: '3 dígitos numéricos',
    glOffsetHint:
      'Selecione uma conta de ativo do plano de contas. Se ficar em branco e houver conta raiz de bancos configurada, a conta é criada no primeiro lançamento.',
    glOptionsLoadError: 'Não foi possível carregar as contas contábeis desta conta.',
    glOptionsRetry: 'Tentar novamente',
    glOffsetHintDirect:
      'Selecione a conta analítica de ativo desta conta. Sem ela, o lançamento não é contabilizado até você selecioná-la. A conta raiz só é escolhida no mapeamento de contas.',
    clear: 'Limpar',
    statementBalanceIncludesSweep:
      'Marque só se o saldo do extrato já soma o valor aplicado. Se o extrato mostra a aplicação separada, deixe desmarcado.',
    investmentBankCode: 'Opcional. Ex.: 102 (XP Investimentos), 208 (BTG)',
    initialBalance:
      'Âncora explícita usada como ponto de partida do cálculo de saldos. Se vazio, o sistema usa o último saldo conhecido (saldo atual) como âncora; se também vazio, usa o último fechamento de extrato; e por último os saldos diários históricos.',
    initialBalanceDate:
      'Data a partir da qual o saldo inicial vale. Deixe vazio para que o sistema escolha automaticamente a melhor âncora disponível.',
    cnabSantanderConvenio: 'Obrigatório para gerar arquivos CNAB de pagamento do Santander (033).',
    accountTypeInvestmentReadOnly:
      'Contas de investimento são criadas via Open Finance e o tipo não pode ser alterado.',
    currencyImmutable: 'A moeda da conta não pode ser alterada após a criação.',
    paymentsEnabled:
      'A Alchemy configurará automaticamente o melhor canal disponível para esta conta.',
    paymentsUnavailable:
      'Ainda não há um canal disponível para este banco, moeda ou tipo de conta.',
  },
  validation: {
    required: 'Preencha este campo para salvar.',
    // Proposed copy: each required message names its field, as on the pilots.
    proposedRequired: {
      entityId: 'Informe a entidade',
      name: 'Informe o nome',
      currencyCode: 'Informe a moeda',
      bankName: 'Informe o nome da plataforma',
      bankCode: 'Informe o banco',
      branchCode: 'Informe a agência',
      accountNumber: 'Informe o número da conta',
      accountType: 'Informe o tipo de conta',
    },
    bankCodeDigits: 'Informe um código de banco com pelo menos 3 dígitos.',
    summary: 'Revise os campos destacados para salvar.',
  },
  glOffsetErrors: {
    NOT_FOUND: 'A conta contábil selecionada não foi encontrada. Selecione outra conta.',
    WRONG_VERSION:
      'A conta contábil selecionada não pertence ao plano de contas em vigor para esta entidade.',
    WRONG_CLASSIFICATION: 'Selecione uma conta de ativo com natureza devedora.',
    NOT_POSTABLE: 'Selecione uma conta analítica, que aceita lançamentos.',
    INACTIVE: 'A conta contábil selecionada está inativa. Selecione uma conta ativa.',
    SLOT_MAPPED:
      'Esta conta já está configurada como conta de sistema no mapeamento de contas. Selecione outra conta.',
    BOUND_TO_OTHER_SUBJECT:
      'Esta conta já está vinculada a um fornecedor, cliente ou posição de investimento. Selecione outra conta.',
    UNDER_OTHER_ROOT:
      'Esta conta fica sob a conta raiz de outra finalidade no mapeamento de contas (por exemplo, investimentos em uma conta corrente). Selecione outra conta.',
    COA_ASSIGNMENT_REQUIRED:
      'Esta entidade ainda não tem livro contábil com plano de contas ativo. Configure o livro e atribua um plano de contas antes de vincular uma conta contábil.',
    fallback: 'A conta contábil selecionada não pode ser vinculada a esta conta bancária.',
  },
  toasts: {
    setDefaultSuccess: 'Conta bancária definida como padrão',
    setDefaultError: 'Erro ao definir conta padrão',
    createSuccess: 'Conta bancária criada com sucesso',
    updateSuccess: 'Conta bancária atualizada com sucesso',
    // ALC-4359 (OQ5): BANK_ACCOUNT_DELETE_BLOCKED_POSTED_GL
    deleteBlockedPostedGl:
      'Esta conta tem lançamentos contábeis ativos. Desfaça as conciliações antes de excluir.',
  },
  actions: {
    cancel: 'Cancelar',
    save: 'Salvar',
    // The form's primary names what it does (alchemy-build-form-page); awaiting approval.
    proposedCreate: 'Criar conta bancária',
    proposedSaveChanges: 'Salvar alterações',
  },
  accessPrototype: {
    title: 'Acesso aos dados',
    columnLabel: 'Acesso',
    manage: 'Gerenciar acesso',
    restricted: 'Restrito',
    inherited: 'Herdado da organização',
    restrictedDescription: 'Somente pessoas e grupos selecionados podem acessar esta conta.',
    restrictedPrototypeTooltip: 'Acesso restrito (protótipo). Clique para revisar.',
    openForAccount: 'Revisar acesso da conta {{name}}',
    inheritedDescription: 'Membros autorizados da organização podem acessar esta conta.',
    canAccess: 'Pode acessar esta conta',
    group: 'Grupo',
    directAccess: 'Acesso direto',
    addPersonOrGroup: 'Adicionar pessoa ou grupo',
    sheetDescription: 'Defina quem pode acessar os dados desta conta bancária.',
    summaryDescription: 'Acesso {{mode}}. Clique para revisar.',
    prototypeNotice: 'Protótipo local: nenhuma alteração de acesso é salva.',
    previousVariant: 'Ver variante anterior',
    nextVariant: 'Ver próxima variante',
    variants: {
      panel: 'A — Painel lateral sob demanda',
      card: 'B — Cartão dentro da página',
      summary: 'C — Resumo compacto',
    },
  },
  access: {
    title: 'Controle de acesso',
    descriptionPrefix: 'Defina quem pode visualizar',
    descriptionSuffix: 'Você pode restringir esta conta a pessoas específicas quando necessário.',
    manageDescription: 'Defina quem pode visualizar os dados de {{bankAccountName}}.',
    inheritedTitle: 'Acesso padrão por função',
    inheritedDescription:
      'Todas as pessoas que já podem acessar contas bancárias podem visualizar esta conta.',
    restrictedTitle: 'Acesso restrito',
    restrictedDescription:
      'Somente as pessoas e grupos adicionados abaixo podem visualizar esta conta. As demais continuam vendo as outras contas às quais têm acesso.',
    restrictionLabel: 'Restringir acesso',
    restrictionDescription:
      'Somente pessoas e grupos autorizados poderão consultar saldos e movimentações desta conta.',
    enableRestriction: 'Restringir acesso',
    disableRestriction: 'Usar acesso padrão',
    manage: 'Gerenciar acesso',
    enableProtection: 'Proteger dados desta conta',
    enableProtectionTitle: 'Proteger os dados desta conta?',
    enableProtectionDescription:
      'As demais pessoas perdem o acesso a {{accountName}} imediatamente, inclusive nos saldos e relatórios. Você mantém o seu acesso para configurar a lista — inclua depois quem deve continuar vendo a conta.',
    protectionEnabled: 'A conta foi protegida. Agora escolha quem poderá acessá-la.',
    restrictionEnabled: 'A conta agora exige uma permissão específica.',
    restrictionDisabled: 'A conta voltou a usar o acesso padrão por função.',
    restrictionError: 'Não foi possível atualizar a política de acesso.',
    enableRestrictionTitle: 'Restringir o acesso a esta conta?',
    enableRestrictionDescription:
      'Apenas as pessoas adicionadas à lista poderão visualizar esta conta. Você continuará com acesso.',
    disableRestrictionTitle: 'Usar o acesso padrão?',
    disableRestrictionDescription_one:
      'Todas as pessoas com permissão para visualizar contas bancárias voltarão a ter acesso a esta conta, e a autorização atual será removida. Se você restringir a conta depois, a lista começa vazia.',
    disableRestrictionDescription_other:
      'Todas as pessoas com permissão para visualizar contas bancárias voltarão a ter acesso a esta conta, e as {{count}} autorizações atuais serão removidas. Se você restringir a conta depois, a lista começa vazia.',
    manageAriaLabel: 'Gerenciar acesso a {{name}}',
    protectAriaLabel: 'Proteger os dados de {{name}}',
    restrictedTooltip: 'Acesso restrito por pessoa',
    restrictedBadge: 'Restrito',
    defaultBadge: 'Padrão',
    inheritedTooltip: 'Acesso padrão por função',
    protectTooltip: 'Proteger dados desta conta',
    addPeople: 'Adicionar pessoas',
    addGroup: 'Adicionar grupo',
    newAccessLevel: 'Nível de acesso para novas permissões',
    movements: 'Saldos e movimentações',
    balancesOnly: 'Somente saldos',
    accessLevelHint:
      'Aplica-se às pessoas e grupos adicionados antes de salvar. “Somente saldos” não permite ver extratos ou transações.',
    selectGroup: 'Selecione um grupo',
    allGroupsHaveAccess: 'Todos os grupos já possuem acesso',
    noGroupsConfigured: 'Nenhum grupo cadastrado',
    groupGrantHint: 'Novas pessoas no grupo também receberão acesso automaticamente.',
    selectPerson: 'Selecione uma pessoa',
    allHaveAccess: 'Todas as pessoas já possuem acesso',
    searchPerson: 'Buscar por nome ou e-mail',
    noEligiblePeople: 'Nenhuma pessoa disponível para adicionar',
    addAnotherPerson: 'Adicionar outra pessoa',
    directGrantHint:
      'As permissões desta lista valem somente para esta conta. Escolha o nível de cada pessoa ou grupo antes de salvar.',
    pendingGrant: 'A adicionar',
    pendingRemoval: 'A remover',
    pendingAccessChange: 'Permissão alterada',
    removePendingAriaLabel: 'Remover {{name}} da lista de espera',
    undoRemovalAriaLabel: 'Manter o acesso de {{name}}',
    undoAccessChangeAriaLabel: 'Desfazer a mudança de nível de {{name}}',
    peopleWithAccess: 'Pessoas com acesso',
    groupsWithAccess: 'Grupos com acesso',
    noGroupsWithAccess: 'Nenhum grupo recebeu acesso ainda.',
    groupAccess: 'Via grupo',
    viaGroups: 'Via grupo: {{groups}}',
    removePendingGroupAriaLabel: 'Remover {{name}} da lista de grupos a adicionar',
    undoGroupRemovalAriaLabel: 'Manter o acesso do grupo {{name}}',
    undoGroupAccessChangeAriaLabel: 'Desfazer a mudança de nível do grupo {{name}}',
    revokeGroupAriaLabel: 'Remover acesso do grupo {{name}}',
    empty: 'Nenhuma pessoa recebeu acesso direto ainda.',
    noRole: 'sem função',
    loadError: 'Não foi possível carregar as permissões desta conta.',
    revokeAriaLabel: 'Remover acesso de {{name}}',
    saveChanges: 'Salvar alterações ({{count}})',
    changesSaved: 'Alterações salvas.',
    saveChangesError: 'Não foi possível salvar todas as alterações. A lista foi atualizada.',
    confirmChangesTitle: 'Salvar alterações de acesso?',
    confirmChangesDescription: 'As permissões de {{accountName}} serão atualizadas agora.',
    confirmChanges_one: 'Salvar {{count}} alteração',
    confirmChanges_other: 'Salvar {{count}} alterações',
    reviewAdditions: 'Adicionar acesso ({{count}})',
    reviewAccessChanges: 'Alterar nível ({{count}})',
    reviewRemovals: 'Remover acesso ({{count}})',
    confirmGrantCount_one: '{{count}} pessoa receberá acesso',
    confirmGrantCount_other: '{{count}} pessoas receberão acesso',
    confirmRemovalCount_one: '{{count}} pessoa perderá acesso',
    confirmRemovalCount_other: '{{count}} pessoas perderão acesso',
    discardChangesTitle: 'Descartar alterações?',
    discardChangesDescription: 'As permissões que ainda não foram salvas serão perdidas.',
    discardChangesConfirm: 'Descartar alterações',
    cancel: 'Cancelar',
  },
  statusOptions: {
    ACTIVE: 'Ativa',
    INACTIVE: 'Inativa',
    DRAFT: 'Rascunho',
    PENDING_VERIFICATION: 'Pendente de verificação',
  },
  statusBadges: {
    ACTIVE: 'Ativa',
    INACTIVE: 'Inativa',
    DRAFT: 'Rascunho',
    PENDING_VERIFICATION: 'Pendente',
  },
  rowActions: {
    openMenu: 'Abrir menu de ações',
    edit: 'Editar',
    inactivate: 'Inativar',
    delete: 'Excluir',
  },
  accountTypeOptions: {
    CHECKING: 'Conta Corrente',
    SAVINGS: 'Conta Poupança',
    INVESTMENT: 'Conta Investimento',
    PAYMENT: 'Conta Pagamento',
  },
  origin: {
    manual: 'Manual',
    openFinance: 'Open Finance',
    api: 'Integração via API',
  },
  sharedAccountNumber: {
    checkingHint: 'Conta corrente (mesmo número da carteira de investimentos)',
    investmentHint: 'Carteira de investimentos (Open Finance)',
    tooltip:
      'No Itaú Empresas, a conta corrente e a carteira de investimentos podem compartilhar o mesmo número de agência/conta. São contas distintas no Alchemy.',
  },
  paymentOperations: {
    title: 'Envio de pagamentos',
    pageTitle: 'Pagamentos · {{account}}',
    configure: 'Configurar',
    loadError: 'Não foi possível carregar a configuração desta conta.',
    setupStatus: {
      DISABLED: 'Desabilitado',
      CONFIGURING: 'Configurando',
      READY: 'Pronta',
      ERROR: 'Requer atenção',
    },
    van: {
      status: {
        NOT_REQUESTED: 'Não solicitada',
        PENDING: 'Solicitada',
        TESTING: 'Em homologação',
        HOMOLOGATED: 'Ativa',
        DEGRADED: 'Comunicação instável',
        SUSPENDED: 'Suspensa',
      },
    },
    journey: {
      title: 'Preparação para pagamentos',
      readyTitle: 'Como esta conta paga',
      checking: 'Verificando',
      unavailable: 'Não foi possível verificar',
      summary: {
        off: 'O envio automático está desligado: o arquivo é gerado aqui e levado ao banco. Para a conta enviar sozinha, habilite o envio ao editá-la.',
        configuring: 'A configuração desta conta ainda está em andamento.',
        ready: 'Esta conta está pronta para enviar pagamentos.',
        unavailable:
          'Não foi possível verificar como esta conta envia. Tente de novo em instantes.',
        noTypes:
          'O canal está pronto, mas nenhuma modalidade foi liberada ainda: nada sai desta conta até a primeira homologação.',
        api: 'Esta conta envia sozinha, pela API do banco.',
        brex: 'Esta conta envia sozinha, por transferência ACH em dólar, pela API do Brex.',
        apiWithReserve:
          'Esta conta envia sozinha, pela API do banco. Se a API recusar antes de aceitar, a VAN bancária envia.',
        van: 'Esta conta envia sozinha, pela VAN bancária.',
        gateway: 'Esta conta envia sozinha, pelo gateway de pagamento.',
        file: 'Esta conta ainda não envia sozinha: o arquivo é gerado aqui e levado ao banco.',
        attention: {
          connection:
            'A conexão da empresa com o banco não está ativa: nada sai desta conta até um administrador reconectar em Integrações.',
          brexConnection:
            'A conexão com o Brex não está ativa: nada sai desta conta até um administrador reconectar o token em Integrações.',
          setup: 'A configuração não foi concluída: nada sai desta conta até a revisão.',
          letter: 'A carta ao banco falhou: a VAN bancária não recebe esta conta até resolver.',
          van: 'A VAN bancária está com problema: confirme no banco se os arquivos chegaram antes de enviar de novo.',
          dda: 'O DDA desta conta precisa de atenção.',
          types: 'As modalidades desta conta precisam de atenção.',
          reserve: 'A reserva desta conta precisa de atenção.',
        },
      },
      admin: {
        show: 'Mostrar operação do gateway',
        hide: 'Ocultar operação do gateway',
      },
      brexConnection: {
        title: 'Empresa conectada ao Brex',
      },
      connection: {
        title: 'Empresa conectada ao banco',
        open: 'Ver conexão',
        lapsedAt: 'Expirou em {{date}}.',
        available: 'Conectada. Esta conta ainda envia por arquivo.',
        notAvailable: 'Conecte a empresa em Integrações para esta conta enviar pela API do banco.',
        useApi: 'Usar a API do banco',
        useApiConfirmTitle: 'Enviar pela API do banco?',
        useApiConfirmDescription:
          'A partir de agora, os pagamentos desta conta saem pela API do banco e cada envio é aprovado no app do banco. As modalidades abrem conforme a homologação de cada uma. É possível voltar ao arquivo depois.',
        useApiSuccess: 'A conta passou a enviar pela API do banco.',
        useApiError: 'Não foi possível trocar o envio desta conta. Tente de novo.',
        useApiBlocked:
          'Há envios em andamento nesta conta. Aguarde o retorno do banco e tente de novo.',
        useFile: 'Voltar a enviar por arquivo',
        useFileConfirmTitle: 'Voltar a enviar por arquivo?',
        useFileConfirmDescription:
          'Os pagamentos desta conta deixam de sair pela API do banco: o arquivo volta a ser gerado aqui e levado ao banco, ou enviado pela VAN se ela estiver ligada. As modalidades homologadas na API ficam guardadas para quando voltar.',
        useFileSuccess: 'A conta voltou a enviar por arquivo.',
        status: {
          ACTIVE: 'Ativa',
          PENDING: 'Aguardando autorização',
          LAPSED: 'Expirou',
          REVOKED: 'Revogada',
          NOT_CONNECTED: 'Não conectada',
        },
      },
      setup: {
        registered: 'Conta cadastrada para envio',
        linked: 'Conta habilitada para envio',
        linkedVan: 'Conta ligada à VAN bancária',
        linkedGateway: 'Conta ligada ao gateway de pagamento',
        offDetail: 'Habilite o envio de pagamentos ao editar esta conta.',
        byTeam: 'A carta ao banco e a ligação à VAN são feitas pela equipe da Alchemy ERP.',
        errorDetail:
          'A configuração não foi concluída e nada sai desta conta enquanto isso. É configuração feita pela equipe da Alchemy ERP: peça a revisão e, depois dela, habilite o envio de novo.',
        errorDetailAdmin:
          'A configuração não foi concluída e nada sai desta conta enquanto isso. Corrija na operação do gateway, abaixo.',
      },
      letter: {
        title: 'Carta ao banco',
        hint: 'O banco libera esta conta para a VAN depois de receber a carta assinada.',
        agreement: 'Convênio nº {{number}}.',
        status: {
          NOT_STARTED: 'Não iniciada',
          LETTER_REQUESTED: 'Pronta para baixar',
          LETTER_DOWNLOADED: 'Baixada, falta enviar ao gerente',
          LETTER_SENT_TO_MANAGER: 'Com o gerente, aguardando o banco',
          BANK_APPROVED: 'Aprovada pelo banco',
          ACTIVE: 'Aprovada pelo banco',
          ERROR: 'Requer atenção',
        },
      },
      van: {
        title: 'VAN bancária',
        hint: 'Com a VAN ativa, o arquivo vai ao banco sozinho.',
        doneDetail: 'O arquivo vai ao banco sozinho.',
      },
      dda: {
        title: 'DDA',
        open: 'Abrir caixa',
        active: 'Ativo',
        viaConnection: 'Pela conexão com o banco',
        letterPending: 'Carta assinada não enviada',
        needsConnection: 'Depende da conexão com o banco',
      },
      types: {
        title: 'Modalidades',
        count: '{{can}} de {{total}} liberadas',
        none: 'Nenhuma registrada',
        noneDetail: 'As modalidades aparecem aqui quando a conta começa a ser homologada.',
        test: 'Testar',
        sheetDescription: 'Teste e histórico de homologação desta modalidade nesta conta.',
        firstUse: 'Primeiro uso deste tipo neste canal; recomendamos um teste controlado.',
        mark: {
          active: 'Liberada',
          pilot: 'Liberada em piloto',
          awaitingBank: 'Aguardando o banco',
          refused: 'Recusada pelo banco',
          suspended: 'Suspensa',
        },
      },
      reserve: {
        title: 'Reserva por VAN bancária',
        ready: 'Pronta',
        testing: 'Em homologação',
        none: 'Não configurada',
        detail: 'Entra só por ação explícita, depois que a API recusou antes de aceitar.',
      },
    },
  },
  paymentTests: {
    title: 'Pagamentos de teste',
    descriptionManual:
      'Gere uma remessa de até R$ 5,00 para validar o arquivo antes do primeiro lote real. O teste não cria uma conta a pagar.',
    descriptionVan:
      'Envie até R$ 5,00 para validar geração, transmissão e retorno bancário pela VAN. O teste não cria uma conta a pagar.',
    disabled: 'Habilite o envio de pagamentos e conclua a configuração da conta antes de testar.',
    readOnly:
      'Você pode consultar o histórico, mas precisa gerenciar integrações para criar ou validar testes.',
    success: 'Pagamento de teste criado e remessa solicitada.',
    send: 'Gerar pagamento de teste',
    sendSelected: 'Enviar teste de {{method}}',
    selectedHint: 'Preencha somente os dados exigidos para esta modalidade.',
    refresh: 'Validar agora',
    history: 'Histórico',
    empty: 'Nenhum teste realizado.',
    waiting: 'aguardando',
    result: 'Transporte: {{transport}} · Pagamento: {{payment}} · Remessa: {{remittance}}',
    fields: {
      instruction: 'Modalidade',
      amount: 'Valor',
      pixKey: 'Chave PIX',
      brCode: 'PIX copia e cola',
      paymentCode: 'Código de pagamento',
      beneficiary: 'Favorecido',
      taxId: 'CPF/CNPJ',
      bank: 'Banco',
      branch: 'Agência',
      account: 'Conta',
    },
    instructions: {
      PIX_KEY: 'PIX por chave',
      PIX_DYNAMIC_QR: 'PIX copia e cola',
      BILLET: 'Boleto',
      UTILITY_BILLET: 'Concessionária',
      TAX_BARCODE: 'Tributo com código de barras',
      DARF: 'DARF',
      BANK_TRANSFER: 'Transferência',
    },
    shortcuts: {
      PIX_KEY: 'Testar PIX',
      PIX_DYNAMIC_QR: 'Testar PIX copia e cola',
      BILLET: 'Testar boleto',
      UTILITY_BILLET: 'Testar concessionária',
      TAX_BARCODE: 'Testar tributo',
      DARF: 'Testar DARF',
      BANK_TRANSFER: 'Testar TED',
    },
    status: {
      CREATED: 'Criado',
      REMITTANCE_PROCESSING: 'Gerando remessa',
      SENT: 'Enviado',
      RETURN_RECEIVED: 'Retorno recebido',
      PASSED: 'Validado',
      FAILED: 'Falhou',
      UNKNOWN: 'Indeterminado',
      CANCELLED: 'Cancelado',
    },
    errors: {
      load: 'Falha ao carregar testes',
      amount: 'O pagamento de teste deve estar entre R$ 0,01 e R$ 5,00.',
      send: 'Falha ao gerar teste',
      refresh: 'Falha ao validar teste',
    },
  },
  providerTests: {
    title: 'Homologação de pagamentos',
    description:
      'Cada modalidade fica bloqueada até um pagamento real de teste, de até R$ 5,00, ser confirmado pelo banco em produção. Informe os dados do teste ou escolha um pagamento agendado desta conta.',
    disabled: 'Habilite o envio de pagamentos e conclua a configuração da conta antes de testar.',
    readOnly:
      'Você pode consultar o histórico, mas precisa gerenciar integrações para enviar ou validar testes.',
    modes: {
      label: 'Origem do pagamento de teste',
      synthetic: 'Dados informados',
      scheduled: 'Pagamento agendado',
    },
    syntheticHint:
      'O pagamento de teste é enviado ao gateway de pagamento na hora, sem conta a pagar por trás. Use um favorecido seu para receber o valor de volta.',
    sendPermission:
      'Enviar um teste é um pagamento real: além de gerenciar integrações, você precisa da permissão de enviar pagamentos.',
    fields: {
      instruction: 'Modalidade',
      payment: 'Pagamento de teste',
      amount: 'Valor (R$)',
      pixKey: 'Chave PIX',
      brCode: 'Código PIX copia e cola',
      paymentCode: 'Código de barras ou linha digitável',
      revenueCode: 'Código da receita',
      beneficiary: 'Favorecido',
      taxId: 'CPF ou CNPJ do favorecido',
      bank: 'Banco do favorecido',
      branch: 'Agência (ex.: 1234 ou 1234-5)',
      account: 'Conta com dígito (ex.: 12345-6)',
    },
    instructionPlaceholder: 'Selecione a modalidade',
    paymentPlaceholder: 'Selecione um pagamento agendado',
    noCandidates:
      'Nenhum pagamento agendado de até R$ 5,00 desta conta pode ser enviado como teste. Agende um pagamento real de pequeno valor por esta conta e volte aqui.',
    candidate: '{{payee}} · {{amount}} · {{date}}',
    send: 'Enviar pagamento de teste',
    success: 'Pagamento de teste enviado pelo gateway de pagamento.',
    refresh: 'Validar agora',
    history: 'Histórico',
    loadingHistory: 'Carregando o histórico de testes',
    loadingCandidates: 'Carregando os pagamentos agendados',
    empty: 'Nenhum teste realizado.',
    result: 'Ambiente: {{environment}} · Resposta do banco: {{status}}',
    waiting: 'aguardando',
    environments: {
      production: 'produção',
      test: 'testes',
    },
    instructions: {
      PIX_KEY: 'PIX por chave',
      PIX_DYNAMIC_QR: 'PIX copia e cola',
      BANK_TRANSFER: 'Transferência',
      BILLET: 'Boleto',
      UTILITY_BILLET: 'Concessionária',
      TAX_BARCODE: 'Tributo com código de barras',
      DARF: 'DARF',
      GPS: 'GPS',
      FGTS: 'FGTS',
      GARE: 'GARE',
      IPVA: 'IPVA',
      DPVAT: 'DPVAT',
      PAYCHECK: 'Salário',
      ACH: 'Transferência ACH (EUA)',
    },
    status: {
      CREATED: 'Criado',
      REMITTANCE_PROCESSING: 'Gerando remessa',
      SENT: 'Aguardando o banco',
      RETURN_RECEIVED: 'Retorno recebido',
      PASSED: 'Homologado',
      PASSED_NO_PROMOTION: 'Pago, sem homologar',
      FAILED: 'Falhou',
      UNKNOWN: 'Em revisão',
      CANCELLED: 'Cancelado',
    },
    noPromotion: {
      NON_PRODUCTION_ENVIRONMENT:
        'O banco confirmou o pagamento, mas o envio rodou em ambiente de testes. A modalidade só é liberada por um teste em produção.',
      CAPABILITY_NOT_PROMOTABLE:
        'O banco confirmou o pagamento, mas a modalidade está suspensa nesta conta e não foi liberada.',
    },
    unknownHint:
      'O retorno do banco precisa de revisão antes de qualquer liberação. Veja o pagamento em revisão.',
    unknownSyntheticHint:
      'O gateway de pagamento não confirmou nem recusou o envio. Valide de novo mais tarde; se continuar assim, confira o pagamento no banco.',
    errors: {
      load: 'Não foi possível carregar os testes.',
      candidates: 'Não foi possível carregar os pagamentos agendados.',
      refresh: 'Não foi possível validar o teste.',
      amount: 'O valor do teste deve estar entre R$ 0,01 e R$ 5,00.',
      generic: 'Não foi possível enviar o pagamento de teste.',
      PAYMENT_HOMOLOGATION_PROVIDER_UNSUPPORTED:
        'Esta conta usa outro fluxo de homologação. Use os pagamentos de teste da conta.',
      PAYMENT_HOMOLOGATION_ACCOUNT_NOT_READY:
        'O envio de pagamentos precisa estar habilitado e pronto nesta conta em reais.',
      PAYMENT_HOMOLOGATION_PAYMENT_INELIGIBLE:
        'Este pagamento não serve como teste: confira os dados informados para a modalidade ou, se for um pagamento agendado, ele precisa ser desta conta, nunca ter sido enviado e ter até R$ 5,00.',
      PAYMENT_HOMOLOGATION_INSTRUCTION_MISMATCH:
        'O gateway de pagamento enviaria este pagamento em outra modalidade. Confira os dados ou escolha um pagamento da modalidade em teste.',
      PAYMENT_HOMOLOGATION_ROUTE_UNAVAILABLE:
        'Esta conta não tem a modalidade disponível para teste.',
      PAYMENT_HOMOLOGATION_ALREADY_OPEN:
        'Já existe um teste em andamento para esta modalidade ou este pagamento. Aguarde a resposta do banco.',
      PAYMENT_HOMOLOGATION_SEND_REFUSED:
        'O gateway de pagamento recusou o pagamento de teste. Veja o motivo no histórico e corrija os dados.',
      PAYMENT_HOMOLOGATION_VENDOR_UNAVAILABLE:
        'O gateway de pagamento não respondeu à consulta do teste. Tente validar de novo em alguns minutos.',
    },
  },
  tecnospeed: {
    columnHeader: 'Envio de pagamentos',
    columnTooltip:
      'Gere remessas bancárias pelo Alchemy. A transmissão automática via VAN pode ser habilitada separadamente.',
    integrateAction: 'Habilitar envio de pagamentos',
    configureAction: 'Configurar envio de pagamentos',
    notSupported: 'Não suportado',
    notSupportedTooltip: 'Ainda não há um canal de pagamento disponível para este banco.',
    notConfigured: 'Não configurado',
    notConfiguredTooltip: 'Banco suportado. Habilite o envio de pagamentos ao editar a conta.',
    ready: 'Remessa habilitada',
    readyTooltip: 'A conta está pronta para gerar remessas manuais. A VAN é opcional.',
    pending: 'Em configuração',
    pendingTooltip:
      'Configuração iniciada. Aguardando conclusão do onboarding e liberação do banco.',
    error: 'Falha na configuração',
    errorTooltip: 'Não foi possível concluir a configuração do envio de pagamentos.',
    modalTitle: 'Habilitar envio de pagamentos',
    modalDescription:
      'Você está habilitando a integração de pagamentos para a conta "{{bankAccountName}}".',
    modalInfo:
      'A conta será registrada no provedor e poderá gerar remessas para envio manual ao banco. A VAN e o retorno automático podem ser habilitados depois.',
    modalWarning:
      'Será necessário enviar uma carta de autorização para a gerente de sua conta bancária, o processo pode demorar de até 30 dias, dependendo do relacionamento.',
    enable: 'Habilitar integração',
    enabling: 'Habilitando…',
    integrationSuccess: 'Integração habilitada com sucesso! Aguardando liberação do banco.',
    integrationError: 'Erro ao habilitar integração',
  },
  tableFooter: {
    showing: 'Mostrando {{count}} de {{total}} contas',
  },
  providerMigration: {
    title: 'Gateway de pagamento da conta',
    description:
      'Configuração interna da operação: move esta conta entre TecnoSpeed e Finnet sem perder o que já foi homologado. Só administradores de integrações veem esta seção.',
    current: 'Gateway atual',
    provider: {
      tecnospeed: 'TecnoSpeed',
      finnet: 'Finnet',
    },
    action: {
      FORWARD: 'Migrar para Finnet',
      REVERSE: 'Voltar para TecnoSpeed',
      REPAIR: 'Reconfigurar na Finnet',
    },
    loading: 'Carregando a prévia da migração',
    loadErrorTitle: 'Não foi possível carregar a prévia da migração',
    blockersTitle: 'O que impede a migração',
    blocker: {
      IN_FLIGHT:
        'Há envios abertos ou tentativas pendentes desta conta ({{sends}} envios, {{attempts}} tentativas). Aguarde a conclusão ou conclua-os manualmente.',
      MOVE_NOT_SUPPORTED: 'A migração só move contas entre TecnoSpeed e Finnet.',
      PROVIDER_UNAVAILABLE: 'O gateway de destino não está disponível neste ambiente.',
      FINNET_NOT_ENABLED:
        'A Finnet não está habilitada para esta empresa. A equipe da Alchemy ERP habilita esse gateway.',
      FINNET_MAPPING_REQUIRED:
        'A conta ainda não está ligada a uma configuração da Finnet. Informe o aco_id para ligá-la na migração.',
    },
    acoIdLabel: 'aco_id da configuração Finnet',
    acoIdHint:
      'O identificador é o da configuração Finnet desta empresa. A equipe da Alchemy ERP informa esse número.',
    willSuspend:
      '{{count}} tipos de pagamento de {{provider}} ficarão suspensos, mantidos para a volta.',
    finnetBlocked: 'Os tipos de pagamento da Finnet abrem bloqueados até a homologação de cada um.',
    paymentsOff:
      'O envio de pagamentos está desligado nesta conta: os tipos da Finnet serão abertos quando ele for ligado.',
    restore:
      '{{count}} tipos de pagamento da TecnoSpeed voltam ao estado registrado na migração de {{date}}.',
    noRestore:
      'Não há registro da migração desta conta: os tipos de pagamento da TecnoSpeed continuarão suspensos até serem promovidos.',
    nothingToDo: 'A conta já está no gateway de destino. Nada a fazer.',
    confirmTitle: {
      FORWARD: 'Migrar esta conta para a Finnet?',
      REVERSE: 'Voltar esta conta para a TecnoSpeed?',
      REPAIR: 'Reconfigurar esta conta na Finnet?',
    },
    confirmDescription:
      'Vale para os próximos envios desta conta. A troca é recusada se algo começar a ser enviado dela antes da confirmação.',
    success: 'Gateway da conta atualizado.',
    successNoRestore:
      'Conta de volta à TecnoSpeed. Os tipos de pagamento continuam suspensos: não havia registro da migração.',
    errorBlocked:
      'A migração foi recusada: algo começou a ser enviado desta conta ou a configuração mudou. Atualize a prévia e tente de novo.',
    errorMapping:
      'A Finnet recusou a ligação com esse aco_id. Confira o número com a equipe da Alchemy ERP.',
    errorGeneric: 'Não foi possível concluir a migração. Tente de novo.',
  },
};

export const bankAccountsEn = {
  statementSource: {
    fileOnly: 'Statement from files',
    enable: 'Use statement files only',
    resume: 'Resume Open Finance statements',
    description:
      'Open Finance will stop updating movements and balances for this account. Use Import statement to upload files. Existing history and other accounts on the connection will be preserved.',
    resumeDescription:
      'Open Finance will resume updating movements and balances for this account. Then sync the desired statement period. If statements have been imported, their overlap must be reviewed before resuming sync.',
    confirm: 'Confirm change',
    processingTitle: 'Updating statement source',
    processingDescription:
      'Wait while the account is updated. This window cannot be closed while processing.',
    saved: 'Statement source updated.',
    successDescription: 'The account now uses the selected source. You can close this window.',
    errorTitle: 'The statement source could not be updated',
    retry: 'Try again',
    error:
      'Could not change the source. If statements have been imported, review their overlap before resuming Open Finance.',
    reloadFailed:
      'The statement source was saved, but the account could not be updated. Try again to see the updated data.',
  },
  detail: {
    reloadFailed: 'The account could not be updated. The balance on screen may be out of date.',
  },
  defaultBadge: 'Default',
  defaultTooltip: 'This account is used by default as the payment source',
  setDefault: 'Set as default',
  glOffsetRequired: 'Link the accounting account to allow postings.',
  glOffsetManualLink:
    'No accounting account found for this bank. Link in Settings > Bank accounts and credit cards.',
  glOffsetBannerOne:
    '1 active account without linked accounting account. Edit to link and allow postings.',
  glOffsetBannerMany:
    '{{count}} active accounts without linked accounting account. Edit to link and allow postings.',
  glOffsetBannerOneCreditCard:
    '1 active card without linked accounting account. Edit to link and allow postings.',
  glOffsetBannerManyCreditCard:
    '{{count}} active cards without linked accounting account. Edit to link and allow postings.',
  glOffsetSelectHint:
    'Select the accounting account to link in the GL. Required to allow postings and reconciliation.',
  glOffsetPending: 'GL pending',
  glOffsetPendingTooltip:
    'Accounting account not linked. Click Edit and select an account in the "Accounting account (GL)" field. If none exists, create one in Settings > Chart of accounts.',
  page: {
    titleCreate: 'New bank account',
    titleEdit: 'Edit bank account',
    subtitleCreate: 'Fill in the data to create a new bank account',
    subtitleEdit: 'Update the bank account information',
  },
  sections: {
    basic: 'Basic information',
    banking: 'Banking details',
    pix: 'PIX Keys',
    cnab: 'CNAB Configuration',
    balance: 'Balance',
    payments: 'Payment submission',
  },
  fields: {
    entity: 'Entity',
    status: 'Status',
    name: 'Name',
    description: 'Description',
    glOffsetAccount: 'Accounting account',
    ownerName: 'Account Holder',
    bank: 'Bank',
    bankCode: 'Bank Code',
    bankName: 'Bank Name',
    investmentBankCode: 'Bank code',
    investmentPlatformName: 'Platform name',
    branchCode: 'Branch',
    accountNumber: 'Account Number',
    clabe: 'CLABE',
    accountType: 'Account Type',
    currency: 'Currency',
    isDefault: 'Set as default account',
    // ALC-4327 (Web-AC8): the ALC-4325 sweep flag.
    statementBalanceIncludesSweep:
      'The statement balance includes the automatically invested amount',
    initialBalance: 'Initial Balance',
    paymentsEnabled: 'Enable payment submission',
  },
  // ALC-5154: the account's automatic sweep rules.
  sweepRule: {
    title: 'Automatic sweep',
    description:
      'Lines the bank invests and redeems on its own. On an account whose balance already includes the invested amount, they stay out of the cash flow.',
    tableLabel: 'Automatic sweep rules',
    noActor: 'No record',
    notChanged: 'Never changed',
    markedLink_one: 'View the line this rule marked',
    markedLink_other: 'View the {{number}} lines this rule marked',
    columns: {
      words: 'Description contains',
      direction: 'Direction',
      marked: 'Lines marked',
      createdBy: 'Created by',
      updatedBy: 'Changed by',
      status: 'Status',
    },
    direction: { DEBIT: 'Money out', CREDIT: 'Money in', BOTH: 'Both' },
    status: { active: 'Active', off: 'Off' },
    actions: {
      menu: 'Actions for rule {{words}}',
      edit: 'Edit',
      viewLines: 'View lines',
      turnOff: 'Turn off',
      turnOn: 'Turn on',
    },
    empty: {
      title: 'No rules yet',
      description:
        'Mark a line as an automatic sweep in reconciliation and the system proposes the rule.',
      action: 'Open reconciliation',
    },
  },
  placeholders: {
    selectEntity: 'Select entity',
    selectStatus: 'Select status',
    name: 'e.g. Bradesco Checking Account',
    description: 'Optional bank account description',
    ownerName: 'e.g. COMPANY LLC',
    bankSearch: 'Search by name or code...',
    bankCode: 'e.g. 237',
    bankName: 'e.g. Banco Bradesco S.A.',
    investmentBankCode: 'e.g. 102 (XP), 208 (BTG)',
    investmentPlatformName: 'e.g. XP, BTG, Clear',
    branchCode: 'e.g. 1234',
    accountNumber: 'e.g. 12345-6',
    clabe: '18-digit CLABE',
    selectAccountType: 'Select account type',
    selectCurrency: 'Select currency',
    selectGlAccount: 'Select accounting account to link in GL',
    initialBalance: 'e.g. 10,000.00',
  },
  hints: {
    bankCode: '3 numeric digits',
    glOffsetHint:
      'Select an asset account from the chart of accounts. If left blank and a bank root account is configured, the account is created on the first posting.',
    glOptionsLoadError: 'Could not load the accounting accounts for this account.',
    glOptionsRetry: 'Try again',
    glOffsetHintDirect:
      "Select this account's asset posting account. Without it, the entry is not posted until you select one. The root account is chosen only in account mapping.",
    clear: 'Clear',
    statementBalanceIncludesSweep:
      'Turn on only if the statement balance already includes the invested amount. If the statement shows the investment apart, leave it off.',
    investmentBankCode: 'Optional. e.g. 102 (XP Investimentos), 208 (BTG)',
    initialBalance:
      'Explicit anchor used as the starting point for balance computation. If left blank, the system uses the last known balance (current balance) as anchor; if also blank, falls back to the most recent statement closing; finally historical daily balances.',
    initialBalanceDate:
      'Date from which the initial balance applies. Leave blank to let the system pick the best available anchor automatically.',
    cnabSantanderConvenio: 'Required to generate Santander (033) CNAB payment files.',
    accountTypeInvestmentReadOnly:
      'Investment accounts are created via Open Finance and the type cannot be changed.',
    currencyImmutable: "The account's currency cannot be changed after creation.",
    paymentsEnabled:
      'Alchemy will automatically configure the best channel available for this account.',
    paymentsUnavailable:
      'No payment channel is available for this bank, currency, or account type yet.',
  },
  validation: {
    required: 'Fill in this field to save.',
    proposedRequired: {
      entityId: 'Enter the entity',
      name: 'Enter the name',
      currencyCode: 'Enter the currency',
      bankName: 'Enter the platform name',
      bankCode: 'Enter the bank',
      branchCode: 'Enter the branch',
      accountNumber: 'Enter the account number',
      accountType: 'Enter the account type',
    },
    bankCodeDigits: 'Enter a bank code with at least 3 digits.',
    summary: 'Review the highlighted fields to save.',
  },
  glOffsetErrors: {
    NOT_FOUND: 'The selected accounting account was not found. Select another account.',
    WRONG_VERSION:
      'The selected accounting account is not in the chart of accounts in force for this entity.',
    WRONG_CLASSIFICATION: 'Select an asset account with a debit balance.',
    NOT_POSTABLE: 'Select a posting account.',
    INACTIVE: 'The selected accounting account is inactive. Select an active account.',
    SLOT_MAPPED:
      'This account is already configured as a system account in account mapping. Select another account.',
    BOUND_TO_OTHER_SUBJECT:
      'This account is already linked to a vendor, customer or investment position. Select another account.',
    UNDER_OTHER_ROOT:
      'This account sits under a root account mapped for another purpose (for example, investments on a checking account). Select another account.',
    COA_ASSIGNMENT_REQUIRED:
      'This entity has no book with an active chart of accounts yet. Set up its book and assign a chart of accounts before linking an accounting account.',
    fallback: 'The selected accounting account cannot be linked to this bank account.',
  },
  toasts: {
    setDefaultSuccess: 'Bank account set as default',
    setDefaultError: 'Error setting default bank account',
    createSuccess: 'Bank account created successfully',
    updateSuccess: 'Bank account updated successfully',
    // ALC-4359 (OQ5): BANK_ACCOUNT_DELETE_BLOCKED_POSTED_GL
    deleteBlockedPostedGl:
      'This account has active accounting entries. Undo the reconciliations before deleting it.',
  },
  actions: {
    cancel: 'Cancel',
    save: 'Save',
    proposedCreate: 'Create bank account',
    proposedSaveChanges: 'Save changes',
  },
  accessPrototype: {
    title: 'Data access',
    columnLabel: 'Access',
    manage: 'Manage access',
    restricted: 'Restricted',
    inherited: 'Inherited from organization',
    restrictedDescription: 'Only selected people and groups can access this account.',
    restrictedPrototypeTooltip: 'Restricted access (prototype). Click to review.',
    openForAccount: 'Review access for {{name}}',
    inheritedDescription: 'Authorized organization members can access this account.',
    canAccess: 'Can access this account',
    group: 'Group',
    directAccess: 'Direct access',
    addPersonOrGroup: 'Add person or group',
    sheetDescription: 'Define who can access this bank account data.',
    summaryDescription: '{{mode}} access. Click to review.',
    prototypeNotice: 'Local prototype: no access changes are saved.',
    previousVariant: 'Show previous variant',
    nextVariant: 'Show next variant',
    variants: {
      panel: 'A — On-demand side panel',
      card: 'B — Inline page card',
      summary: 'C — Compact summary',
    },
  },
  access: {
    title: 'Access control',
    descriptionPrefix: 'Choose who can view',
    descriptionSuffix: 'Restrict this account to specific people when needed.',
    manageDescription: 'Choose who can view {{bankAccountName}} data.',
    inheritedTitle: 'Role-based default access',
    inheritedDescription: 'Everyone who can already access bank accounts can view this account.',
    restrictedTitle: 'Restricted access',
    restrictedDescription:
      'Only the people and groups added below can view this account. Everyone else can still view the other accounts they are allowed to access.',
    restrictionLabel: 'Restrict access',
    restrictionDescription:
      'Only authorized people and groups will be able to view this account’s balances and transactions.',
    enableRestriction: 'Restrict access',
    disableRestriction: 'Use default access',
    manage: 'Manage access',
    enableProtection: 'Protect this account’s data',
    enableProtectionTitle: 'Protect this account’s data?',
    enableProtectionDescription:
      'Everyone else loses access to {{accountName}} immediately, including in balances and reports. You keep your own access to configure the list — then add the people who should still see the account.',
    protectionEnabled: 'The account is protected. Now choose who can access it.',
    restrictionEnabled: 'This account now requires a specific permission.',
    restrictionDisabled: 'This account now uses normal role-based access.',
    restrictionError: 'Unable to update the access policy.',
    enableRestrictionTitle: 'Restrict access to this account?',
    enableRestrictionDescription:
      'Only people added to the list will be able to view this account. You will retain access.',
    disableRestrictionTitle: 'Use default access?',
    disableRestrictionDescription_one:
      'Everyone with permission to view bank accounts will regain access to this account, and the current authorization will be removed. If you restrict this account later, the list starts empty.',
    disableRestrictionDescription_other:
      'Everyone with permission to view bank accounts will regain access to this account, and the {{count}} current authorizations will be removed. If you restrict this account later, the list starts empty.',
    manageAriaLabel: 'Manage access to {{name}}',
    protectAriaLabel: 'Protect {{name}} data',
    restrictedTooltip: 'Person-level restricted access',
    restrictedBadge: 'Restricted',
    defaultBadge: 'Default',
    inheritedTooltip: 'Role-based default access',
    protectTooltip: 'Protect this account’s data',
    addPeople: 'Add people',
    addGroup: 'Add group',
    newAccessLevel: 'Access level for new permissions',
    movements: 'Balances and transactions',
    balancesOnly: 'Balances only',
    accessLevelHint:
      'Applies to people and groups added before saving. “Balances only” does not allow statements or transactions.',
    selectGroup: 'Select a group',
    allGroupsHaveAccess: 'All groups already have access',
    noGroupsConfigured: 'No groups configured',
    groupGrantHint: 'People added to this group will receive access automatically.',
    selectPerson: 'Select a person',
    allHaveAccess: 'Everyone already has access',
    searchPerson: 'Search by name or email',
    noEligiblePeople: 'No one is available to add',
    addAnotherPerson: 'Add another person',
    directGrantHint:
      'Permissions in this list apply only to this account. Choose a level for each person or group before saving.',
    pendingGrant: 'To add',
    pendingRemoval: 'To remove',
    pendingAccessChange: 'Permission changed',
    removePendingAriaLabel: 'Remove {{name}} from the waiting list',
    undoRemovalAriaLabel: 'Keep access for {{name}}',
    undoAccessChangeAriaLabel: 'Undo the level change for {{name}}',
    peopleWithAccess: 'People with access',
    groupsWithAccess: 'Groups with access',
    noGroupsWithAccess: 'No group has received access yet.',
    groupAccess: 'Via group',
    viaGroups: 'Via group: {{groups}}',
    removePendingGroupAriaLabel: 'Remove {{name}} from groups to add',
    undoGroupRemovalAriaLabel: 'Keep access for group {{name}}',
    undoGroupAccessChangeAriaLabel: 'Undo the level change for group {{name}}',
    revokeGroupAriaLabel: 'Remove access for group {{name}}',
    empty: 'No one has received direct access yet.',
    noRole: 'no role',
    loadError: 'Unable to load this account’s permissions.',
    revokeAriaLabel: 'Remove access for {{name}}',
    saveChanges: 'Save changes ({{count}})',
    changesSaved: 'Changes saved.',
    saveChangesError: 'Unable to save every change. The list was refreshed.',
    confirmChangesTitle: 'Save access changes?',
    confirmChangesDescription: 'Permissions for {{accountName}} will be updated now.',
    confirmChanges_one: 'Save {{count}} change',
    confirmChanges_other: 'Save {{count}} changes',
    reviewAdditions: 'Add access ({{count}})',
    reviewAccessChanges: 'Change level ({{count}})',
    reviewRemovals: 'Remove access ({{count}})',
    confirmGrantCount_one: '{{count}} person will receive access',
    confirmGrantCount_other: '{{count}} people will receive access',
    confirmRemovalCount_one: '{{count}} person will lose access',
    confirmRemovalCount_other: '{{count}} people will lose access',
    discardChangesTitle: 'Discard changes?',
    discardChangesDescription: 'Any access changes that have not been saved will be lost.',
    discardChangesConfirm: 'Discard changes',
    cancel: 'Cancel',
  },
  statusOptions: {
    ACTIVE: 'Active',
    INACTIVE: 'Inactive',
    DRAFT: 'Draft',
    PENDING_VERIFICATION: 'Pending verification',
  },
  statusBadges: {
    ACTIVE: 'Active',
    INACTIVE: 'Inactive',
    DRAFT: 'Draft',
    PENDING_VERIFICATION: 'Pending',
  },
  rowActions: {
    openMenu: 'Open actions menu',
    edit: 'Edit',
    inactivate: 'Inactivate',
    delete: 'Delete',
  },
  accountTypeOptions: {
    CHECKING: 'Checking Account',
    SAVINGS: 'Savings Account',
    INVESTMENT: 'Investment Account',
    PAYMENT: 'Payment Account',
  },
  origin: {
    manual: 'Manual',
    openFinance: 'Open Finance',
    api: 'API integration',
  },
  sharedAccountNumber: {
    checkingHint: 'Checking account (same number as investment wallet)',
    investmentHint: 'Investment wallet (Open Finance)',
    tooltip:
      'At Itaú Empresas, checking and investment wallets may share the same branch/account number. They are separate accounts in Alchemy.',
  },
  paymentOperations: {
    title: 'Payment submission',
    pageTitle: 'Payments · {{account}}',
    configure: 'Configure',
    loadError: "Could not load this account's setup.",
    setupStatus: {
      DISABLED: 'Disabled',
      CONFIGURING: 'Configuring',
      READY: 'Ready',
      ERROR: 'Needs attention',
    },
    van: {
      status: {
        NOT_REQUESTED: 'Not requested',
        PENDING: 'Requested',
        TESTING: 'In homologation',
        HOMOLOGATED: 'Active',
        DEGRADED: 'Unstable communication',
        SUSPENDED: 'Suspended',
      },
    },
    journey: {
      title: 'Getting ready for payments',
      readyTitle: 'How this account pays',
      checking: 'Checking',
      unavailable: 'Could not check',
      summary: {
        off: 'Automatic submission is off: the file is generated here and taken to the bank. For the account to send on its own, enable submission when editing it.',
        configuring: "This account's setup is still in progress.",
        ready: 'This account is ready to send payments.',
        unavailable: 'Could not check how this account sends. Try again in a moment.',
        noTypes:
          'The channel is ready, but no payment type has been released yet: nothing leaves this account until the first homologation.',
        api: "This account sends on its own, through the bank's API.",
        brex: "This account sends on its own, by ACH transfer in dollars, through Brex's API.",
        apiWithReserve:
          "This account sends on its own, through the bank's API. If the API refuses before accepting, the bank VAN sends.",
        van: 'This account sends on its own, through the bank VAN.',
        gateway: 'This account sends on its own, through the payment gateway.',
        file: 'This account does not send on its own yet: the file is generated here and taken to the bank.',
        attention: {
          connection:
            "The company's connection to the bank is not active: nothing leaves this account until an administrator reconnects it in Integrations.",
          brexConnection:
            'The Brex connection is not active: nothing leaves this account until an administrator reconnects the token in Integrations.',
          setup: 'The setup was not completed: nothing leaves this account until it is reviewed.',
          letter:
            'The letter to the bank failed: the bank VAN will not take this account until it is resolved.',
          van: 'The bank VAN has a problem: confirm with the bank that the files arrived before sending again.',
          dda: "This account's DDA needs attention.",
          types: "This account's payment types need attention.",
          reserve: "This account's reserve needs attention.",
        },
      },
      admin: {
        show: 'Show gateway operations',
        hide: 'Hide gateway operations',
      },
      brexConnection: {
        title: 'Company connected to Brex',
      },
      connection: {
        title: 'Company connected to the bank',
        open: 'View connection',
        lapsedAt: 'Lapsed on {{date}}.',
        available: 'Connected. This account still sends by file.',
        notAvailable:
          "Connect the company in Integrations for this account to send through the bank's API.",
        useApi: "Use the bank's API",
        useApiConfirmTitle: "Send through the bank's API?",
        useApiConfirmDescription:
          "From now on, this account's payments leave through the bank's API and each send is approved in the bank app. Payment types open as each one is homologated. You can go back to file later.",
        useApiSuccess: "The account now sends through the bank's API.",
        useApiError: 'Could not change how this account sends. Try again.',
        useApiBlocked:
          'There are sends in flight on this account. Wait for the bank and try again.',
        useFile: 'Go back to sending by file',
        useFileConfirmTitle: 'Go back to sending by file?',
        useFileConfirmDescription:
          "This account's payments stop leaving through the bank's API: the file is generated here and taken to the bank again, or sent through the VAN when one is linked. The types homologated on the API are kept for when you return.",
        useFileSuccess: 'The account sends by file again.',
        status: {
          ACTIVE: 'Active',
          PENDING: 'Awaiting authorization',
          LAPSED: 'Lapsed',
          REVOKED: 'Revoked',
          NOT_CONNECTED: 'Not connected',
        },
      },
      setup: {
        registered: 'Account registered for submission',
        linked: 'Account enabled for submission',
        linkedVan: 'Account linked to the bank VAN',
        linkedGateway: 'Account linked to the payment gateway',
        offDetail: 'Enable payment submission when editing this account.',
        byTeam: 'The letter to the bank and the VAN link are handled by the Alchemy ERP team.',
        errorDetail:
          'The setup was not completed and nothing leaves this account meanwhile. It is set up by the Alchemy ERP team: ask for a review and, after it, enable submission again.',
        errorDetailAdmin:
          'The setup was not completed and nothing leaves this account meanwhile. Fix it in the gateway operations below.',
      },
      letter: {
        title: 'Letter to the bank',
        hint: 'The bank releases this account to the VAN after receiving the signed letter.',
        agreement: 'Agreement no. {{number}}.',
        status: {
          NOT_STARTED: 'Not started',
          LETTER_REQUESTED: 'Ready to download',
          LETTER_DOWNLOADED: 'Downloaded, send it to the manager',
          LETTER_SENT_TO_MANAGER: 'With the manager, awaiting the bank',
          BANK_APPROVED: 'Approved by the bank',
          ACTIVE: 'Approved by the bank',
          ERROR: 'Needs attention',
        },
      },
      van: {
        title: 'Bank VAN',
        hint: 'With the VAN active, the file reaches the bank on its own.',
        doneDetail: 'The file reaches the bank on its own.',
      },
      dda: {
        title: 'DDA',
        open: 'Open inbox',
        active: 'Active',
        viaConnection: 'Through the bank connection',
        letterPending: 'Signed letter not sent',
        needsConnection: 'Depends on the bank connection',
      },
      types: {
        title: 'Payment types',
        count: '{{can}} of {{total}} released',
        none: 'None registered',
        noneDetail: 'Payment types show up here once the account starts being homologated.',
        test: 'Test',
        sheetDescription: 'Homologation test and history of this payment type on this account.',
        firstUse: 'First use of this kind on this channel; a controlled test is recommended.',
        mark: {
          active: 'Released',
          pilot: 'Released as a pilot',
          awaitingBank: 'Awaiting the bank',
          refused: 'Refused by the bank',
          suspended: 'Suspended',
        },
      },
      reserve: {
        title: 'Bank VAN reserve',
        ready: 'Ready',
        testing: 'Being homologated',
        none: 'Not set up',
        detail: 'Used only by explicit action, after the API refused before accepting.',
      },
    },
  },
  paymentTests: {
    title: 'Test payments',
    descriptionManual:
      'Generate a remittance up to BRL 5.00 to validate the file before the first real batch. The test does not create an account payable.',
    descriptionVan:
      'Send up to BRL 5.00 to validate generation, transmission, and bank return through VAN. The test does not create an account payable.',
    disabled: 'Enable payment submission and finish account setup before testing.',
    readOnly:
      'You can view history, but integration management is required to create or validate tests.',
    success: 'Test payment created and remittance requested.',
    send: 'Generate test payment',
    sendSelected: 'Send {{method}} test',
    selectedHint: 'Fill only the fields required for this payment method.',
    refresh: 'Validate now',
    history: 'History',
    empty: 'No tests yet.',
    waiting: 'waiting',
    result: 'Transport: {{transport}} · Payment: {{payment}} · Remittance: {{remittance}}',
    fields: {
      instruction: 'Method',
      amount: 'Amount',
      pixKey: 'PIX key',
      brCode: 'PIX copy and paste',
      paymentCode: 'Payment code',
      beneficiary: 'Beneficiary',
      taxId: 'Tax ID',
      bank: 'Bank',
      branch: 'Branch',
      account: 'Account',
    },
    instructions: {
      PIX_KEY: 'PIX by key',
      PIX_DYNAMIC_QR: 'PIX copy and paste',
      BILLET: 'Billet',
      UTILITY_BILLET: 'Utility bill',
      TAX_BARCODE: 'Tax with barcode',
      DARF: 'DARF',
      BANK_TRANSFER: 'Bank transfer',
    },
    shortcuts: {
      PIX_KEY: 'Test PIX',
      PIX_DYNAMIC_QR: 'Test PIX copy and paste',
      BILLET: 'Test billet',
      UTILITY_BILLET: 'Test utility bill',
      TAX_BARCODE: 'Test tax payment',
      DARF: 'Test DARF',
      BANK_TRANSFER: 'Test wire transfer',
    },
    status: {
      CREATED: 'Created',
      REMITTANCE_PROCESSING: 'Generating remittance',
      SENT: 'Sent',
      RETURN_RECEIVED: 'Return received',
      PASSED: 'Validated',
      FAILED: 'Failed',
      UNKNOWN: 'Unknown',
      CANCELLED: 'Cancelled',
    },
    errors: {
      load: 'Failed to load tests',
      amount: 'The test payment must be between BRL 0.01 and BRL 5.00.',
      send: 'Failed to generate test',
      refresh: 'Failed to validate test',
    },
  },
  providerTests: {
    title: 'Payment homologation',
    description:
      'Each payment type stays blocked until a real test payment of up to BRL 5.00 is confirmed by the bank in production. Type the test details or choose a scheduled payment from this account.',
    disabled: 'Enable payment submission and finish setting up the account before testing.',
    readOnly:
      'You can view the history, but you need to manage integrations to send or validate tests.',
    modes: {
      label: 'Source of the test payment',
      synthetic: 'Typed details',
      scheduled: 'Scheduled payment',
    },
    syntheticHint:
      'The test payment goes to the payment gateway right away, with no bill behind it. Use a payee of your own to get the amount back.',
    sendPermission:
      'Sending a test is a real payment: besides managing integrations, you need the permission to send payments.',
    fields: {
      instruction: 'Payment type',
      payment: 'Test payment',
      amount: 'Amount (BRL)',
      pixKey: 'PIX key',
      brCode: 'PIX copy and paste code',
      paymentCode: 'Bar code or digitable line',
      revenueCode: 'Revenue code',
      beneficiary: 'Payee',
      taxId: 'Payee CPF or CNPJ',
      bank: 'Payee bank',
      branch: 'Branch (e.g. 1234 or 1234-5)',
      account: 'Account with check digit (e.g. 12345-6)',
    },
    instructionPlaceholder: 'Select the payment type',
    paymentPlaceholder: 'Select a scheduled payment',
    noCandidates:
      'No scheduled payment of up to BRL 5.00 from this account can be sent as a test. Schedule a small real payment from this account and come back.',
    candidate: '{{payee}} · {{amount}} · {{date}}',
    send: 'Send test payment',
    success: 'Test payment sent through the payment gateway.',
    refresh: 'Validate now',
    history: 'History',
    loadingHistory: 'Loading the test history',
    loadingCandidates: 'Loading the scheduled payments',
    empty: 'No tests yet.',
    result: 'Environment: {{environment}} · Bank answer: {{status}}',
    waiting: 'waiting',
    environments: {
      production: 'production',
      test: 'test',
    },
    instructions: {
      PIX_KEY: 'PIX by key',
      PIX_DYNAMIC_QR: 'PIX copy and paste',
      BANK_TRANSFER: 'Transfer',
      BILLET: 'Boleto',
      UTILITY_BILLET: 'Utility bill',
      TAX_BARCODE: 'Tax with bar code',
      DARF: 'DARF',
      GPS: 'GPS',
      FGTS: 'FGTS',
      GARE: 'GARE',
      IPVA: 'IPVA',
      DPVAT: 'DPVAT',
      PAYCHECK: 'Salary',
      ACH: 'ACH transfer (US)',
    },
    status: {
      CREATED: 'Created',
      REMITTANCE_PROCESSING: 'Generating remittance',
      SENT: 'Waiting for the bank',
      RETURN_RECEIVED: 'Return received',
      PASSED: 'Homologated',
      PASSED_NO_PROMOTION: 'Paid, not homologated',
      FAILED: 'Failed',
      UNKNOWN: 'Under review',
      CANCELLED: 'Cancelled',
    },
    noPromotion: {
      NON_PRODUCTION_ENVIRONMENT:
        'The bank confirmed the payment, but the send ran in a test environment. The payment type is only enabled by a test in production.',
      CAPABILITY_NOT_PROMOTABLE:
        'The bank confirmed the payment, but the payment type is suspended on this account and was not enabled.',
    },
    unknownHint:
      "The bank's answer needs review before anything is enabled. See the payment under review.",
    unknownSyntheticHint:
      'The payment gateway neither confirmed nor refused the send. Validate again later; if it stays this way, check the payment at the bank.',
    errors: {
      load: 'Could not load the tests.',
      candidates: 'Could not load the scheduled payments.',
      refresh: 'Could not validate the test.',
      amount: 'The test amount must be between BRL 0.01 and BRL 5.00.',
      generic: 'Could not send the test payment.',
      PAYMENT_HOMOLOGATION_PROVIDER_UNSUPPORTED:
        "This account uses another homologation flow. Use the account's test payments.",
      PAYMENT_HOMOLOGATION_ACCOUNT_NOT_READY:
        'Payment submission must be enabled and ready on this BRL account.',
      PAYMENT_HOMOLOGATION_PAYMENT_INELIGIBLE:
        'This payment cannot be the test: check the typed details for the payment type or, for a scheduled payment, it must be from this account, never sent and at most BRL 5.00.',
      PAYMENT_HOMOLOGATION_INSTRUCTION_MISMATCH:
        'The payment gateway would send this payment as another payment type. Check the details or choose a payment of the type under test.',
      PAYMENT_HOMOLOGATION_ROUTE_UNAVAILABLE:
        'This account has no such payment type available to test.',
      PAYMENT_HOMOLOGATION_ALREADY_OPEN:
        'A test is already running for this payment type or this payment. Wait for the bank answer.',
      PAYMENT_HOMOLOGATION_SEND_REFUSED:
        'The payment gateway refused the test payment. See the reason in the history and fix the details.',
      PAYMENT_HOMOLOGATION_VENDOR_UNAVAILABLE:
        'The payment gateway did not answer the test lookup. Try validating again in a few minutes.',
    },
  },
  tecnospeed: {
    columnHeader: 'Payment submission',
    columnTooltip:
      'Generate bank remittances through Alchemy. Automatic VAN transmission can be enabled separately.',
    integrateAction: 'Enable payment submission',
    configureAction: 'Configure payment submission',
    notSupported: 'Not supported',
    notSupportedTooltip: 'No payment channel is available for this bank yet.',
    notConfigured: 'Not configured',
    notConfiguredTooltip: 'Supported bank. Enable payment submission when editing the account.',
    ready: 'Remittance enabled',
    readyTooltip: 'The account is ready to generate manual remittances. Bank VAN is optional.',
    pending: 'Being configured',
    pendingTooltip: 'Setup started. Awaiting onboarding completion and bank authorization.',
    error: 'Setup failed',
    errorTooltip: 'Payment submission setup could not be completed.',
    modalTitle: 'Enable payment submission',
    modalDescription: 'You are enabling payment integration for account "{{bankAccountName}}".',
    modalInfo:
      'The account will be registered with the provider and can generate files for manual bank submission. Bank VAN and automatic returns can be enabled later.',
    modalWarning:
      'An authorization letter will need to be sent to your bank account manager. The process may take up to 30 days depending on your relationship.',
    enable: 'Enable integration',
    enabling: 'Enabling…',
    integrationSuccess: 'Integration enabled successfully! Awaiting bank authorization.',
    integrationError: 'Error enabling integration',
  },
  tableFooter: {
    showing: 'Showing {{count}} of {{total}} accounts',
  },
  providerMigration: {
    title: "Account's payment gateway",
    description:
      'Internal operations setting: moves this account between TecnoSpeed and Finnet without losing what was already homologated. Only integration administrators see this section.',
    current: 'Current gateway',
    provider: {
      tecnospeed: 'TecnoSpeed',
      finnet: 'Finnet',
    },
    action: {
      FORWARD: 'Migrate to Finnet',
      REVERSE: 'Move back to TecnoSpeed',
      REPAIR: 'Set up again on Finnet',
    },
    loading: 'Loading the migration preview',
    loadErrorTitle: 'Could not load the migration preview',
    blockersTitle: 'What blocks the migration',
    blocker: {
      IN_FLIGHT:
        'This account has open sends or pending attempts ({{sends}} sends, {{attempts}} attempts). Wait for them to finish or conclude them manually.',
      MOVE_NOT_SUPPORTED: 'The migration only moves accounts between TecnoSpeed and Finnet.',
      PROVIDER_UNAVAILABLE: 'The destination gateway is not available in this environment.',
      FINNET_NOT_ENABLED:
        'Finnet is not enabled for this company. The Alchemy ERP team enables that gateway.',
      FINNET_MAPPING_REQUIRED:
        'The account is not linked to a Finnet configuration yet. Enter the aco_id to link it during the migration.',
    },
    acoIdLabel: 'Finnet configuration aco_id',
    acoIdHint:
      "This is the identifier of this company's Finnet configuration. The Alchemy ERP team provides that number.",
    willSuspend: '{{count}} {{provider}} payment types will be suspended, kept for the way back.',
    finnetBlocked: 'Finnet payment types open blocked until each one is homologated.',
    paymentsOff:
      'Payment sending is off on this account: the Finnet payment types will open when it is turned on.',
    restore:
      '{{count}} TecnoSpeed payment types return to the state recorded by the migration of {{date}}.',
    noRestore:
      'There is no record of this account’s migration: the TecnoSpeed payment types stay suspended until they are promoted.',
    nothingToDo: 'The account is already on the destination gateway. Nothing to do.',
    confirmTitle: {
      FORWARD: 'Migrate this account to Finnet?',
      REVERSE: 'Move this account back to TecnoSpeed?',
      REPAIR: 'Set this account up again on Finnet?',
    },
    confirmDescription:
      'Applies to the next sends from this account. The change is refused if anything starts being sent from it before you confirm.',
    success: "The account's gateway was updated.",
    successNoRestore:
      'The account is back on TecnoSpeed. Its payment types stay suspended: there was no record of the migration.',
    errorBlocked:
      'The migration was refused: something started being sent from this account or the setup changed. Refresh the preview and try again.',
    errorMapping:
      'Finnet refused the link with that aco_id. Check the number with the Alchemy ERP team.',
    errorGeneric: 'Could not complete the migration. Try again.',
  },
};
